import { orderBy } from 'lodash';
import React from 'react';

import { titleize } from '../../util';

const DualIntegersDualAnswers = ({ data }) =>
  data
    ? orderBy(data, 'value', 'desc').map((answer, i) =>
        i === 0 ? (
          <span key={`answer-${i}`}>
            {titleize(answer.key)} {answer.value}
          </span>
        ) : (
          <span key={`answer-${i}`}> - {answer.value}</span>
        )
      )
    : null;

export default DualIntegersDualAnswers;
